import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dark-mode"
export default class extends Controller {
  static targets = ["icon"]

  connect() {
    // Initialize theme from localStorage or default to light
    const savedTheme = localStorage.getItem('theme') || 'light'
    this.setTheme(savedTheme, false)
  }

  // Toggle between light and dark themes
  toggle(event) {
    event?.preventDefault()
    const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light'
    const newTheme = currentTheme === 'light' ? 'dark' : 'light'
    this.setTheme(newTheme, true)
  }

  // Set theme and update UI
  setTheme(theme, save = true) {
    // Update data-bs-theme attribute on html element
    document.documentElement.setAttribute('data-bs-theme', theme)

    // Update icon if target exists
    if (this.hasIconTarget) {
      this.updateIcon(theme)
    }

    // Save to localStorage
    if (save) {
      localStorage.setItem('theme', theme)
    }
  }

  // Update icon based on theme
  updateIcon(theme) {
    const icon = this.iconTarget
    if (theme === 'dark') {
      icon.className = 'fas fa-moon'
    } else {
      icon.className = 'fas fa-sun'
    }
  }

  // Get current theme
  getCurrentTheme() {
    return document.documentElement.getAttribute('data-bs-theme') || 'light'
  }
}
